import { useState, useEffect } from 'react';

export function useIsDesktop(breakpoint = 992) {
  const [isDesktop, setIsDesktop] = useState(false); // safe default

  useEffect(() => {
    const checkScreen = () => setIsDesktop(window.innerWidth >= breakpoint);
    checkScreen(); // run once on mount

    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, [breakpoint]);

  return isDesktop;
}
